var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import React from 'react';
function TabPanel(_a) {
    var props = __rest(_a, []);
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return (_jsx("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}` }, other, { children: value === index && (_jsx(Box, Object.assign({ sx: {
                p: 3,
            } }, { children: _jsx(Typography, { children: children }) }))) })));
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export default function TabsExample() {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (_jsxs(Box, Object.assign({ sx: {
            flexGrow: 1,
            bgcolor: 'background.paper',
        } }, { children: [_jsx(Box, Object.assign({ sx: {
                    position: 'static',
                } }, { children: _jsxs(Tabs, Object.assign({ value: value, onChange: handleChange, "aria-label": "simple tabs example" }, { children: [_jsx(Tab, Object.assign({ label: "Recents" }, a11yProps(0))), _jsx(Tab, Object.assign({ label: "Favourites" }, a11yProps(1))), _jsx(Tab, Object.assign({ label: "Nearby" }, a11yProps(2)))] })) })), _jsx(TabPanel, Object.assign({ value: value, index: 0 }, { children: "Item One" })), _jsx(TabPanel, Object.assign({ value: value, index: 1 }, { children: "Item Two" })), _jsx(TabPanel, Object.assign({ value: value, index: 2 }, { children: "Item Three" })), _jsx(Box, Object.assign({ sx: {
                    position: 'static',
                } }, { children: _jsxs(Tabs, Object.assign({ value: value, onChange: handleChange, "aria-label": "simple tabs example" }, { children: [_jsx(Tab, Object.assign({ icon: _jsx(PhoneIcon, {}), label: "Recents" }, a11yProps(0))), _jsx(Tab, Object.assign({ icon: _jsx(FavoriteIcon, {}), label: "Favourites" }, a11yProps(1))), _jsx(Tab, Object.assign({ icon: _jsx(PersonPinIcon, {}), label: "Nearby" }, a11yProps(2)))] })) })), _jsx(TabPanel, Object.assign({ value: value, index: 0 }, { children: "Item One" })), _jsx(TabPanel, Object.assign({ value: value, index: 1 }, { children: "Item Two" })), _jsx(TabPanel, Object.assign({ value: value, index: 2 }, { children: "Item Three" }))] })));
}
